/* eslint-disable @typescript-eslint/no-explicit-any */
import request from '@/utils/request'

//获取角色的菜单和按钮权限
export const getRole = (data: { id: string | number }) => {
  return request.post('/role/getRole', data)
}

// 列表
export function list(data: any) {
  return request.post('/role/list', data)
}

// 列表（下拉）
export function roleList(data: any) {
  return request.post('/role/roleList', data)
}

// 新增
export function add(data: any) {
  return request.post('/role/add', data)
}

// 编辑
export function update(data: any) {
  return request.post('/role/update', data)
}

// 删除
export function remove(data: any) {
  return request.post('/role/delete', data)
}
